const getters = {
	pageBackgroundColor(state, getters) {
		return state.pageBackgroundColor;
	},

	cardBackgroundColor(state, getters) {
		return state.cardBackgroundColor;
	},

	hignlightBorderColor(state, getters) {
		return state.hignlightBorderColor;
	},

	cardBtnBackgroundColor(state, getters) {
		return state.cardBtnBackgroundColor;
	},

	primaryBtnBackgroundColor(state, getters) {
		return state.primaryBtnBackgroundColor;
	},

	virtualCurrencyUnit(state, getters) {
		return state.virtualCurrencyUnit;
	},
};

export default getters